module.exports = __webpack_public_path__ + "static/media/mcafee.b2f0aa5f.png";